import "./App.css";

import { Link } from "react-router-dom";
import TrainingProviderOnboardingBody from "./TrainingProviderOnboardingBody";
import TrainingProviderOnboardingHero from "./TrainingProviderOnboardingHero";

const partnershipEmail =
  "mailto:contact@fit-match.co.uk?subject=Training%20provider%20onboarding";

const shareUrl = "fit-match.co.uk/onboarding-training-provider";

/**
 * Standalone onboarding page for training providers (shareable link).
 * Not linked from the main site navigation — use /onboarding-training-provider
 */
function OnboardingTrainingProvider() {
  return (
    <div className="bg-black text-gray-200 min-h-screen">
      <header className="bg-black bg-opacity-90 backdrop-blur-lg sticky top-0 w-full z-50 border-b border-gray-800">
        <nav className="container mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-4">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-12 w-auto md:h-14"
            />
            <span className="text-xl md:text-2xl font-bold gradient-text">
              FIT-MATCH
            </span>
          </Link>
          <div className="flex items-center gap-4 text-sm md:text-base">
            <Link to="/" className="text-gray-300 hover:text-white nav-link">
              Home
            </Link>
            <a
              href={partnershipEmail}
              className="text-green-400 hover:text-green-300 font-medium"
            >
              Contact us
            </a>
          </div>
        </nav>
      </header>

      <main>
        <TrainingProviderOnboardingHero />
        <TrainingProviderOnboardingBody
          shareUrl={shareUrl}
          partnershipEmail={partnershipEmail}
        />
      </main>

      <footer className="bg-gray-900 py-8 text-center text-gray-500 text-sm border-t border-gray-800">
        <Link to="/" className="hover:text-gray-300">
          ← Back to Fit-Match home
        </Link>
        <p className="mt-4">
          &copy; {new Date().getFullYear()} Fit-Match. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default OnboardingTrainingProvider;
